<template>
    <SoliForm
        v-if="product"
        @reset="$emit('reset')"
        @submit="submit()"
        :title="product.name"
        :textSubtitle="$page.props.auth.user.selected_location.name"
        ref="form"
    >
        <template #body>
            <SoliText
                number
                v-model="form.current_stock"
                label="Current Supply"
                icon="inventory_2"
            />
            <SoliText
                number
                v-model="form.recommended_stock"
                label="Recommended Supply"
                icon="assignment_turned_in"
            />
            <SoliText
                number
                v-model="form.warning_stock"
                label="Warning Supply"
                icon="warning_amber"
            />
        </template>
    </SoliForm>
</template>

<script>
export default {
    props: {
        product: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            form: this.$inertia.form({
                current_stock: this.product.price.inventory.current_stock,
                recommended_stock:
                    this.product.price.inventory.recommended_stock,
                warning_stock: this.product.price.inventory.warning_stock,
            }),
        };
    },
    methods: {
        submit() {
            this.form.put(
                `/location-price/${this.product.price.inventory.id}`,
                {
                    preserveState: true,
                    preserveScroll: true,
                    onSuccess: () => {
                        this.$emit("success");
                        this.$emit("reset");
                    },
                    onError: () => {
                        console.log(
                            "Form returned errors: " +
                                JSON.stringify(this.errors)
                        );
                    },
                }
            );
        },
    },
};
</script>
